import { getAllPendingSessions, removePendingSession, type PendingSession } from "./db";

/** Attempt to sync all pending offline sessions to the server */
export async function syncPendingSessions(): Promise<{ synced: number; failed: number; reviewsSynced: number }> {
  const pending = await getAllPendingSessions();
  if (pending.length === 0) return { synced: 0, failed: 0, reviewsSynced: 0 };

  let synced = 0;
  let failed = 0;
  let reviewsSynced = 0;

  for (const session of pending) {
    try {
      const success = await syncOneSession(session);
      if (success) {
        await removePendingSession(session.id);
        synced++;
        reviewsSynced += session.reviews.length;
      } else {
        failed++;
      }
    } catch {
      failed++;
    }
  }

  return { synced, failed, reviewsSynced };
}

async function syncOneSession(session: PendingSession): Promise<boolean> {
  // Step 1: Create the server session
  const createRes = await fetch("/api/sessions", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ deckId: session.deckId }),
  });

  if (!createRes.ok) {
    // 429 (limit) or 401 (unauth) — can't sync this one now
    return false;
  }

  const { session: serverSession } = await createRes.json();

  // Step 2: Submit all reviews in a batch
  const patchRes = await fetch(`/api/sessions/${serverSession.id}/review`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      correctCount: session.correctCount,
      durationSeconds: session.durationSeconds,
      reviews: session.reviews,
    }),
  });

  return patchRes.ok;
}
